export type {
  RatingDisplaySlots,
  RatingDisplayBaseProps as RatingDisplayProps,
  RatingDisplayBaseState as RatingDisplayState,
  RatingDisplayContextValues,
} from '@fluentui/react-rating';
